

define(['squid/index', './directive', './addcard/route', './selectcard/route', './addbilling/route', './addCep/route', '../confirm-upop/route'], function (squid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    squid.module('xo-add-card.route', ['squid', 'xo-add-card.directive', 'xo-add-card.addcard.route', 'xo-add-card.selectcard.route', 'xo-add-card.addbilling.route', 'xo-add-card.addcep.route', 'xo-confirm-upop.route']).factory('$AddCardFlowRoute', function ($ComponentRoute) {

        return $ComponentRoute.extend('CardRoute', {

            name: 'addCardFlow',
            directive: 'xo-add-card-flow',
            titleContent: 'asideHeader.addCard',
            children: [{
                name: '$AddCardRoute',
                attributes: {
                    token: 'token',
                    cardmodel: 'cardmodel',
                    done: 'addCCDone',
                    message: 'message',
                    pagetitle: 'pagetitle',
                    sidebar: 'sidebar',
                    showmeftsection: 'showmeftsection',
                    hideparenthead: 'hideparenthead',
                    billingaddressupdated: 'billingaddressupdated',
                    isupdatecard: 'isupdatecard',
                    'parent-callbacks': 'callbacks',
                    'selected-promotion-card-type': 'selectedPromotionCardType',
                    promotion: 'promotion',
                    'page-level': 'pageLevel',
                    logout: 'logout',
                    phone: 'phone',
                    'on-success': 'onSuccess',
                    'back-uri': 'backUri'
                }

            }, {
                name: '$SelectCardRoute',
                attributes: {
                    token: 'token',
                    'parent-callbacks': 'callbacks',
                    message: 'message',
                    pagetitle: 'pagetitle',
                    sidebar: 'sidebar',
                    'selected-promotion-card-type': 'selectedPromotionCardType',
                    promotion: 'promotion'
                }
            }, {
                name: '$AddBillingRoute',
                attributes: {
                    token: 'token',
                    sidebar: 'sidebar',
                    showmeftsection: 'showmeftsection',
                    'parent-callbacks': 'callbacks',
                    hideparenthead: 'hideparenthead',
                    billingaddressupdated: 'billingaddressupdated',
                    'prefill-address': 'prefillAddress'
                }
            }, {
                name: '$AddCepRoute',
                attributes: {
                    token: 'token',
                    sidebar: 'sidebar',
                    'done-fn': 'cepDone',
                    'prefill-address': 'prefillAddress'
                }
            }]
        });
    });
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-wallet-components/src/add-card/route.js
// module id = ./components/xo-wallet-components/src/add-card/route.js
// module chunks = 1